function WarningMessage({ message }) {
  if (!message) return null;
  return <p className="login-warning">{message}</p>;
}

export default WarningMessage;
